import { render } from "./App.vue?vue&type=template&id=622a0dba"
const script = {}

import "./App.vue?vue&type=style&index=0&id=622a0dba&lang=less"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.6_vue@3.4.6_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__